import React, { useState } from "react";
import "../assets/css/component-input-file.css";

export default function InputFile({ setImageGroupe, currentImage }) {
  const [preview, setPreview] = useState(currentImage || null);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const MAX_SIZE = 512;
    const QUALITY = 0.8;

    const img = new Image();
    img.onload = () => {
      let { width, height } = img;
      if (width > MAX_SIZE || height > MAX_SIZE) {
        if (width > height) {
          height = Math.round((height * MAX_SIZE) / width);
          width = MAX_SIZE;
        } else {
          width = Math.round((width * MAX_SIZE) / height);
          height = MAX_SIZE;
        }
      }
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      canvas.getContext("2d").drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        (blob) => {
          const resizedFile = new File([blob], file.name, { type: "image/jpeg" });
          setPreview(canvas.toDataURL("image/jpeg", QUALITY));
          setImageGroupe(resizedFile);
        },
        "image/jpeg",
        QUALITY
      );
      URL.revokeObjectURL(img.src);
    };
    img.src = URL.createObjectURL(file);
  };

  return (
    <div className="my-container-folder-for-file">
      {preview ? (
        <img src={preview} width="100%" style={{ maxHeight: 200, objectFit: "cover" }} alt="image_du_groupe" />
      ) : (
        <div className="my-folder-for-file">
          <div className="my-top-folder-for-file"></div>
          <div className="my-bottom-folder-for-file"></div>
        </div>
      )}
      <label className="custom-file-upload">
        <input
          className="title"
          type="file"
          accept="image/*"
          onChange={handleImageChange}
        />
        Choisissez une image (Facultative)
      </label>
    </div>
  );
}
